module.exports = __webpack_public_path__ + "img/xiaoqi.09ed5ae3.png";